import { api } from '../../lib/api';

const state = {
  token: null,
};

const getters = {
  getToken: state => state.token,
};

const mutations = {
  setToken(state, { token }) {
    state.token = token;
  },
  clearUserToken(state) {
    state.token = null;
  },
};

const actions = {
  async authenticate({ commit }, { email, password }) {
    const response = await api.post(`api/auth-tokens`, { email, password });

    const { token } = response.data;

    commit('setToken', { token });
    commit('user/setUser', { token }, { root: true });
  },
  setUserToken({ commit, getters }) {
    const token = getters.getToken;

    if (token) {
      commit('setToken', { token });
      commit('user/setUser', { token }, { root: true });
    }
  },
};

export default { namespaced: true, actions, state, getters, mutations };
